import request from '../../infra/request';
import { ASSESSMENT_TYPE } from '../data/constants';
import { isAutismAssessment } from '../utils/fee';
import type { FeeQuote, FeeSelection, MedicareType } from '../utils/fee';

interface FeeQuoteResponse {
  success?: boolean;
  _embedded?: FeeQuote;
}

const isFeeQuote = (value: unknown): value is FeeQuote => (
  typeof value === 'object'
  && value !== null
  && typeof (value as FeeQuote).gross === 'number'
  && typeof (value as FeeQuote).hasAsdPathway === 'boolean'
  && typeof (value as FeeQuote).includesPsychiatricReviewFee === 'boolean'
);

/** Server fee for a complete set of answers. Autism sends no prescribing answer. */
export const fetchFeeQuote = async (
  state: string,
  medicareType: MedicareType,
  selection: FeeSelection,
): Promise<FeeQuote> => {
  const { data } = await request.get<FeeQuoteResponse>(
    '/assessment-requests/fee-quote',
    {
      params: {
        assessmentType: ASSESSMENT_TYPE,
        state,
        medicareType,
        location: selection.location,
        feeAssessmentScope: selection.feeAssessmentScope,
        ...(isAutismAssessment(selection.feeAssessmentScope)
          ? {}
          : { prescriptionType: selection.prescriptionType }),
        seenPsychiatrist: selection.seenPsychiatrist,
      },
    },
  );
  const quote = data?._embedded; // eslint-disable-line no-underscore-dangle
  if (!isFeeQuote(quote)) {
    throw new Error('Unexpected fee quote response');
  }
  return quote;
};
